const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoCoinag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#e21d19"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "9 5.95 5.47 8 4.57 7.13 6.49 5.36 4.93 5.36 3 7.02 9 13.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9 11.43 8.4 10.84 9 10.43 9 11.43",
    style: {
      fill: "#e21d19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.67 10.13 9 9.3 9 8.59 7.21 9.68 7.67 10.13",
    style: {
      fill: "#e21d19"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "6.46 8.96 9 7.51 9 6.91 6.11 8.62 6.46 8.96",
    style: {
      fill: "#e21d19"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "9 5.95 12.53 8 13.43 7.13 11.51 5.36 13.07 5.36 15 7.02 9 13.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9 11.43 9.6 10.84 9 10.43 9 11.43",
    style: {
      fill: "#e21d19"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.33 10.13 9 9.3 9 8.59 10.79 9.68 10.33 10.13",
    style: {
      fill: "#e21d19"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "11.54 8.96 9 7.51 9 6.91 11.89 8.62 11.54 8.96",
    style: {
      fill: "#e21d19"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoCoinag);
export default __webpack_public_path__ + "static/media/banco-coinag.88b5b723e9c0dfcf2cc2fed9ad0b7bbd.svg";
export { ForwardRef as ReactComponent };